import VueMaterial from "vue-material";
//import "vue-material/dist/vue-material.min.css";
import "@/assets/vue-material.min.css";
import "@/assets/scss/material-kit.scss";
import "@/assets/demo.css";
import basicMixins from "./basicMixins";
import globalDirectives from "./globalDirectives";
import globalMixins from "./globalMixins";
import globalComponents from "./globalComponents";
import VueLazyload from "vue-lazyload";

export default {
  install(Vue) {
    Vue.use(VueMaterial);
    Vue.use(globalDirectives);
    Vue.use(globalMixins);
    Vue.use(basicMixins);
    Vue.use(globalComponents);
    Vue.use(VueLazyload, {
      lazyComponent: true,
      observer: true,
      // optional
      observerOptions: {
        rootMargin: "0px",
        threshold: 0.1,
      },
    });
  },
};
